export type IMenuItem = {
	link: string;
	title: string;
};

export type MenuComposerParam = {
	menuItem: IMenuItem | IMenuItem[];
	enabled: () => boolean;
};

export function MenuComposer(menu: MenuComposerParam[]): IMenuItem[] {
	return menu.reduce((r: IMenuItem[], c: MenuComposerParam) => {
		if (c.enabled()) {
			if (Array.isArray(c.menuItem)) return [...r, ...c.menuItem];
			return [...r, c.menuItem];
		} else return r;
	}, []);
}
